export default "__VITE_ASSET__Da7qbFiV__"